export function formatCurrency(data, returnType) {
  let dollars = data.toString();
  dollars = dollars.replace(/\D/g, "");
  let cleanMoney = "";
  let textMoney = "";

  let numbersize = dollars.length - 1;

  for (let a = numbersize; a >= 0; a--) {
    cleanMoney = cleanMoney + dollars[a];
  }
  for (let a = numbersize; a >= 0; a--) {
    textMoney = textMoney + cleanMoney[a];
    if (a >= 1 && a % 3 === 0) {
      textMoney = textMoney + ",";
    }
  }

  const intMoney = parseInt(dollars) || 0;

  if (returnType === "both") {
    return {
      textMoney,
      intMoney,
    };
  }

  return textMoney;
}
export const emailValidation =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const onlyNumber = /^\d+$/;
export const onlyLetter = /^[a-zA-Z]+$/;
export const onlyLetterSpace = /^[a-zA-Z\s]*$/;
export const noSpaces = /^\S*$/;
